export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  views: string;
  publishDate: string;
  duration: string;
  isTop: boolean;
  tags: string[];
}

export const categories: { name: string; slug: string; description: string; icon: string; count: string; imageUrl: string }[] = [
  {
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '每日网红翻车事件第一时间追踪报道，揭露网红背后的真相',
    icon: 'ri-alert-line',
    count: '12,580',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20art%20concept%20of%20a%20spotlight%20falling%20down%20on%20a%20stage%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20golden%20tones%2C%20symbolic%20abstract%20illustration%20representing%20revelation%20and%20truth%2C%20modern%20minimalist%20style%20with%20soft%20gradients%2C%20clean%20composition%2C%20editorial%20quality&width=800&height=600&seq=cat-wanghong-01&orientation=landscape'
  },
  {
    name: '黑料曝光',
    slug: 'heiliao-baoguang',
    description: '独家深挖网红不为人知的幕后黑料，还原事件真相',
    icon: 'ri-spy-line',
    count: '9,234',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20digital%20illustration%20of%20a%20magnifying%20glass%20over%20dark%20shadows%2C%20warm%20amber%20and%20deep%20coral%20color%20palette%2C%20minimalist%20composition%20with%20dramatic%20contrast%2C%20mystery%20and%20investigation%20theme%2C%20clean%20modern%20design%2C%20editorial%20photography%20style&width=800&height=600&seq=cat-heiliao-02&orientation=landscape'
  },
  {
    name: '吃瓜视频',
    slug: 'chigua-shipin',
    description: '最新最全的网红八卦吃瓜视频合集，热门爆料视频实时更新',
    icon: 'ri-live-line',
    count: '18,762',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20of%20vibrant%20social%20media%20feed%20with%20floating%20video%20elements%2C%20warm%20coral%20pink%20and%20golden%20amber%20gradients%2C%20modern%20minimalist%20digital%20art%2C%20playful%20and%20energetic%20vibe%2C%20clean%20composition%2C%20editorial%20quality&width=800&height=600&seq=cat-chigua-03&orientation=landscape'
  },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '某千万粉丝网红深夜直播翻车，粉丝集体脱粉回踩',
    excerpt: '拥有超过两千万粉丝的知名网红在昨晚的直播中因不当言论引发轩然大波，大量粉丝在社交平台发声表示失望并宣布脱粉，事件持续发酵中。',
    content: '<p>昨晚（7月6日），拥有超过两千万粉丝的知名网红"小晴天"在例行直播中，因对粉丝提问的不当回应引发大规模争议。</p><p>在直播进行到约一小时时，一位粉丝提问关于其代言产品质量的问题，小晴天以极其傲慢的态度回应："买不起就别买，没人逼你。"此言一出，直播间弹幕瞬间炸锅。</p><p>随后，大量粉丝在微博、抖音等社交平台发起话题 #小晴天翻车#，话题阅读量在短短三小时内突破5亿。多位资深粉丝晒出多年来为其消费的记录，表示"心寒至极"。</p><p>截至目前，该网红尚未就此事作出正式回应，但其微博账号已关闭评论功能。据第三方数据平台显示，其抖音账号在事件发生后已掉粉超过80万。</p><p>业内人士分析认为，此次事件折射出当前网红经济的深层问题——部分头部网红在获取巨大流量和商业利益后，逐渐脱离了与粉丝之间的情感纽带，忘记了初心。</p><p>本网将持续关注此事进展，为大家带来最新报道。</p>',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20digital%20illustration%20of%20a%20spotlight%20crashing%20down%20on%20a%20stage%2C%20warm%20coral%20and%20deep%20amber%20color%20palette%2C%20symbolic%20representation%20of%20a%20public%20figure%20falling%20from%20grace%2C%20modern%20minimalist%20style%2C%20clean%20composition%20with%20dramatic%20lighting%2C%20editorial%20quality&width=1200&height=800&seq=article-wanghong-01&orientation=landscape',
    views: '128.5万',
    publishDate: '2026-07-07',
    duration: '05:32',
    isTop: true,
    tags: ['网红', '翻车', '直播', '脱粉', '小晴天'],
  },
  {
    id: 2,
    title: '揭秘：顶流美食博主后厨卫生状况触目惊心',
    excerpt: '本报记者暗访某拥有三千万粉丝的美食博主线下餐厅，发现后厨存在严重的卫生问题，食材过期、蟑螂乱爬，与镜头前精致形象形成鲜明对比。',
    content: '<p>近日，本报接到多位消费者投诉，称某知名美食博主线下实体餐厅食品卫生状况堪忧。记者随即展开暗访调查。</p><p>该美食博主在全网拥有超过三千万粉丝，以"精致美食家"人设走红，其视频中展示的菜品精美绝伦，吸引了大量粉丝前往其线下餐厅打卡消费。</p><p>然而，暗访画面显示，该餐厅后厨食材随意堆放、过期食材未及时清理、操作台面油污堆积，甚至在墙角发现了蟑螂活动的痕迹。暗访记者还拍到厨师在处理食材时未佩戴手套和口罩。</p><p>食品安全专家表示，这样的卫生状况严重违反《食品安全法》相关规定，存在极大的食品安全隐患。</p><p>目前，当地市场监管部门已介入调查。该博主尚未对此事作出公开回应，但其社交媒体账号已设置为私密状态。</p>',
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20kitchen%20scene%20abstract%20digital%20art%20with%20warm%20amber%20light%20revealing%20shadows%2C%20dramatic%20contrast%20between%20clean%20and%20dirty%20surfaces%2C%20investigative%20journalism%20theme%2C%20minimalist%20composition%2C%20editorial%20photography%20style&width=1200&height=800&seq=article-heiliao-02&orientation=landscape',
    views: '95.3万',
    publishDate: '2026-07-06',
    duration: '08:15',
    isTop: false,
    tags: ['美食博主', '卫生问题', '暗访', '食品安全'],
  },
  {
    id: 3,
    title: '吃瓜！两大顶流网红互撕聊天记录全曝光',
    excerpt: '两大头部网红因商业合作纠纷在朋友圈隔空互怼，随后双方聊天记录被第三方曝光，内容劲爆引发全网热议，吃瓜群众直呼过瘾。',
    content: '<p>昨晚深夜，两大头部网红"阿飞"和"大G"在各自的朋友圈展开了一场隔空骂战，起因是一笔高达千万的商业合作纠纷。</p><p>据知情人士透露，二人原本计划联合创办一家MCN机构，但因利益分配问题产生严重分歧。阿飞率先在朋友圈发文暗讽大G"过河拆桥"，大G随即以更激烈的言辞回击。</p><p>双方互撕的聊天记录随后被一名自称"圈内好友"的第三方曝光，内容涉及合作细节、资金流向以及二人私下对彼此的负面评价，言辞之激烈让吃瓜群众直呼"太精彩了"。</p><p>相关话题迅速登上微博热搜榜第一位，话题阅读量突破10亿。网友纷纷站队，形成了两派阵营。</p><p>业内人士指出，网红之间的公开互撕虽然能短期内吸引流量关注，但长期来看对双方的商业价值和公众形象都会造成不可逆的损害。</p>',
    category: '吃瓜视频',
    categorySlug: 'chigua-shipin',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20abstract%20figures%20facing%20each%20other%20with%20dramatic%20lightning%20bolt%20between%20them%2C%20warm%20coral%20and%20golden%20amber%20color%20palette%2C%20confrontation%20and%20drama%20theme%2C%20modern%20minimalist%20digital%20illustration%2C%20clean%20composition%2C%20editorial%20quality&width=1200&height=800&seq=article-chigua-03&orientation=landscape',
    views: '256.8万',
    publishDate: '2026-07-05',
    duration: '12:48',
    isTop: false,
    tags: ['网红互撕', '聊天记录', '商业纠纷', '热搜'],
  },
  {
    id: 4,
    title: '知名带货主播被曝卖假货，品牌方连夜发声明撇清关系',
    excerpt: '消费者购买某头部带货主播推荐的大牌护肤品后发现为假货，检测报告证实后品牌方紧急发声明称与该主播无合作关系，主播团队面临信任危机。',
    content: '<p>近日，多位消费者在社交平台发帖称，在某头部带货主播的直播间购买的国际大牌护肤品经专业机构检测为假冒产品。</p><p>消费者小王（化名）向记者展示了她购买的产品和检测报告："瓶身的字体印刷模糊，气味和专柜正品完全不一样，检测报告确认是假货。"</p><p>事件的发酵引发了更多消费者的共鸣，陆续有人晒出在该主播直播间购买到疑似假货的购物凭证。涉及的品牌包括多个国际知名护肤品牌，涉及金额总计超过500万元。</p><p>品牌方在得知此事后连夜发布声明，表示与该主播从未建立过官方合作关系，所售产品来源不明，提醒消费者通过官方渠道购买。</p><p>该主播团队目前已删除相关直播回放，并表示将对供应链进行彻查。但消费者维权群已聚集超过3000人，部分消费者已向市场监管部门投诉。</p>',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fake%20luxury%20product%20being%20examined%20under%20magnifying%20glass%20abstract%20digital%20art%2C%20warm%20coral%20red%20warning%20tones%2C%20counterfeit%20detection%20theme%2C%20minimalist%20modern%20composition%2C%20dramatic%20lighting%2C%20editorial%20quality&width=1200&height=800&seq=article-wanghong-04&orientation=landscape',
    views: '189.2万',
    publishDate: '2026-07-04',
    duration: '06:45',
    isTop: false,
    tags: ['带货', '假货', '护肤品', '维权'],
  },
  {
    id: 5,
    title: '深扒：百万粉网红背后竟然是AI虚拟人？',
    excerpt: '技术团队通过深度分析发现，某拥有数百万粉丝的"美女网红"实为AI生成的虚拟形象，背后运营团队通过技术手段制造虚假人设牟取暴利。',
    content: '<p>在人工智能技术飞速发展的今天，AI虚拟网红已经成为一个新兴的灰色产业。近日，一个技术团队通过深度图像分析发现，某拥有超过五百万粉丝的"美女网红"竟完全由AI生成。</p><p>该技术团队负责人表示："我们通过分析其发布的数千张照片和视频，发现了多个AI生成内容的典型特征，包括不自然的皮肤纹理、一致的面部比例偏差以及光线折射的不合理性。"</p><p>更令人震惊的是，这个AI虚拟网红背后有一个完整的运营团队，他们利用AI语音合成技术与粉丝进行"语音互动"，通过AI驱动的内容矩阵进行商业变现，年收入据估计超过千万元。</p><p>目前，相关社交平台已对该账号进行标记处理。法律专家指出，利用AI虚拟人设进行商业活动而未向消费者明示，涉嫌违反《消费者权益保护法》和《广告法》相关规定。</p><p>这一事件引发了公众对AI虚拟网红现象的广泛讨论，人们在感叹技术发展的同时也对信息真实性产生了深深的忧虑。</p>',
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20face%20dissolving%20into%20pixels%20and%20code%2C%20warm%20amber%20and%20coral%20gradient%2C%20AI%20artificial%20intelligence%20theme%2C%20modern%20minimalist%20digital%20illustration%2C%20mysterious%20and%20revealing%20atmosphere%2C%20editorial%20quality&width=1200&height=800&seq=article-heiliao-05&orientation=landscape',
    views: '312.6万',
    publishDate: '2026-07-03',
    duration: '09:20',
    isTop: false,
    tags: ['AI虚拟人', '造假', '揭秘', '技术分析'],
  },
  {
    id: 6,
    title: '吃瓜合集：本周最劲爆的5个网红塌房事件盘点',
    excerpt: '本周网红圈地震不断，从财务造假到情感纠纷，从税务问题到团队内讧，我们为你盘点本周最劲爆的五大塌房事件，一个比一个精彩。',
    content: '<p>本周的网红圈可谓多事之秋，各种塌房事件接连不断，让吃瓜群众目不暇接。以下是本周最值得关注的五大塌房事件盘点：</p><p><strong>TOP5：某情感博主被前男友曝光PUA话术</strong></p><p>一位拥有百万粉丝的情感博主，被前男友曝出大量私密聊天记录，揭露其所谓"恋爱秘籍"实为精心设计的PUA话术。</p><p><strong>TOP4：游戏主播代打实锤</strong></p><p>知名游戏主播被粉丝实锤使用代打，其直播中展示的高超操作实为他人代劳，本人仅负责出镜解说。</p><p><strong>TOP3：美妆博主整容前后对比照流出</strong></p><p>一位以"纯天然"人设走红的美妆博主，其整容前照片被曝光，与当前形象判若两人。</p><p><strong>TOP2：财经大V推荐股票导致粉丝巨亏</strong></p><p>某财经大V推荐的多只股票在一周内暴跌超50%，大量跟投粉丝损失惨重，质疑其存在"割韭菜"行为。</p><p><strong>TOP1：头部MCN机构被曝刷量造假</strong></p><p>行业头部MCN机构被前员工曝光系统性刷量造假，涉及旗下数百位网红，引发行业地震。</p>',
    category: '吃瓜视频',
    categorySlug: 'chigua-shipin',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collage%20of%20five%20dramatic%20news%20headlines%20as%20abstract%20digital%20art%2C%20warm%20coral%20pink%20and%20golden%20amber%20color%20palette%2C%20weekly%20recap%20entertainment%20theme%2C%20modern%20minimalist%20clean%20composition%2C%20editorial%20quality&width=1200&height=800&seq=article-chigua-06&orientation=landscape',
    views: '478.1万',
    publishDate: '2026-07-02',
    duration: '15:30',
    isTop: false,
    tags: ['盘点', '合集', '塌房', '本周热点'],
  },
];